<script>
import eventBus from '@utils/eventBus'

import Card from '@components/prague-attraction-card.vue'
import Translatable from '@src/mixins/translatable.js'

export default {
  name: 'AttractionsGrid',
  components: {
    Card
  },
  mixins: [
    Translatable
  ],
  props: {
    attractions: {
      type: Array,
      required: true
    },
    displayCalculator: {
      type: Boolean
    },
    attractionsToDisplay: {
      type: Number
    }
  },
  data() {
    return {
      initialDisplay: 15,
      incrementAttraction: 30,
      incrementAttractionFullscreen: 32,
      initialDisplayFullscreen: 16,
      expanded: false
    }
  },
  computed: {
    displayedAttractions() {
      return this.attractions.slice(0, this.attractionsToDisplay)
    },
    btnLabel() {
      return this.attractions.length > this.attractionsToDisplay ? 'SHOW_MORE' : 'SHOW_LESS'
    }
  },
  created() {
    eventBus.$on('toggle', () => {
      this.expanded = !this.expanded

      if (this.expanded) {
        this.$store.commit('attractions/SET_ATTRACTIONS_TO_DISPLAY', this.initialDisplayFullscreen)
      } else {
        this.$store.commit('attractions/SET_ATTRACTIONS_TO_DISPLAY', this.initialDisplay)
      }
    })
  },
  beforeDestroy() {
    eventBus.$off('toggle')
  },
  methods: {
    toggleAttractions() {
      if (this.attractionsToDisplay < this.attractions.length) {
        this.moreAttractions()
      } else {
        this.scrollToElement({behavior: 'smooth'})
        setTimeout(() => this.lessAttractions(), 1000)
      }
    },
    moreAttractions() {
      if (this.expanded) {
        this.$store.commit('attractions/SET_ATTRACTIONS_TO_DISPLAY', this.attractionsToDisplay + this.incrementAttractionFullscreen)
      } else {
        this.$store.commit('attractions/SET_ATTRACTIONS_TO_DISPLAY', this.attractionsToDisplay + this.incrementAttraction)
      }
    },
    lessAttractions() {
      if (this.expanded) {
        this.$store.commit('attractions/SET_ATTRACTIONS_TO_DISPLAY', this.initialDisplayFullscreen)
      } else {
        this.$store.commit('attractions/SET_ATTRACTIONS_TO_DISPLAY', this.initialDisplay)
      }
    },
    scrollToElement(options) {
      const el = document.querySelector('#all-attractions')

      if (el) {
        el.scrollIntoView(options);
      }
    },
  }
}
</script>

<template>
  <div class="grid-container">
    <div ref="grid" class="attractions-grid" :class="expanded ? 'expanded' : ''">
      <Card
        v-for="attraction in displayedAttractions"
        :key="attraction._id"
        :attraction="attraction"
      />
    </div>
    <div class="more-btn container">
      <button
        v-if="attractions.length > initialDisplay"
        class="show-more-btn"
        @click.prevent="toggleAttractions"
      >
        {{ getTranslatedContent(btnLabel) }}
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.attractions-grid {
  display: grid;
  column-gap: 20px;
  row-gap: 15px;
  grid-template-columns: repeat(3, 1fr);

  &.expanded {
    grid-template-columns: repeat(4, 1fr);
  }
}

.show-more-btn {
  width: 270px;
  height: 48px;
  margin-top: 15px;

  border: 1px solid $dark-gray;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: white;


  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 15px;
  line-height: 19px;
  text-align: center;
  text-transform: uppercase;
  color: rgba(37, 44, 62, 0.6);

  &:hover {
    border: 1px solid rgba(37, 44, 62, 0.6);
  }
}

.more-btn {
  display: flex;
  justify-content: flex-end;

  &.container {
    min-width: auto;
    width: auto;
  }
}

@media only screen and (min-width: $mobile-container-width) and (max-width: $container-width-xs) {

  ::v-deep .card-container {
    width: 100% !important;
    height: 204px !important;
    border-radius: 0;
  }

  ::v-deep .card-footer {
    border-radius: 0;
  }

  .attractions-grid {
    grid-template-columns: repeat(1, 1fr);
    row-gap: 5px;
  }

  .show-more-btn {
    width: 100%;
    margin-top: 10px;

    &:hover {
      border: 1px solid $dark-gray;
    }

    &:active {
      border: 1px solid rgba(37, 44, 62, 0.6);
    }
  }
}

</style>
